import { render, staticRenderFns } from "./MudarSenha.vue?vue&type=template&id=badfd9fa&scoped=true"
import script from "./MudarSenha.vue?vue&type=script&lang=js"
export * from "./MudarSenha.vue?vue&type=script&lang=js"
import style0 from "./MudarSenha.vue?vue&type=style&index=0&id=badfd9fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badfd9fa",
  null
  
)

export default component.exports